<ng-template #container></ng-template>
<div  class="notification-box" [class.notification-box-show]="showCookiesClaim">
  <p>本網站使用Cookies收集資料用於量化統計與分析，以進行服務品質之改善。請點選"接受"，若未做任何選擇，或將本視窗關閉，本站預設選擇拒絕。進一步Cookies資料之處理，請參閱本站之<a routerLink="./privacy" target="_blank" title="隱私權宣告[{{'openNewWindow' | translate}}]">隱私權宣告</a>。</p>
  <button type="button" (click)="acceptCookies()">接受</button>
</div>